// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CompanyableResourceController from "./companyable_resource_controller"
application.register("companyable-resource", CompanyableResourceController)

import FactCircleController from "./fact_circle_controller"
application.register("fact-circle", FactCircleController)

import FieldController from "./field_controller"
application.register("field", FieldController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlippingCircleController from "./flipping_circle_controller"
application.register("flipping-circle", FlippingCircleController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import InfinitescrollController from "./infinitescroll_controller"
application.register("infinitescroll", InfinitescrollController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ListedObjectClassOnFilterController from "./listed_object_class_on_filter_controller"
application.register("listed-object-class-on-filter", ListedObjectClassOnFilterController)

import MapController from "./map_controller"
application.register("map", MapController)

import MultiSelectFixController from "./multi_select_fix_controller"
application.register("multi-select-fix", MultiSelectFixController)

import SiteTitleController from "./site_title_controller"
application.register("site-title", SiteTitleController)

import ThemeParkObjectListedController from "./theme_park_object_listed_controller"
application.register("theme-park-object-listed", ThemeParkObjectListedController)

import VisitsCalendarController from "./visits_calendar_controller"
application.register("visits-calendar", VisitsCalendarController)
